import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const RotateImage = forwardRef<SVGSVGElement, SvgIconProps>(
  function RotateImage(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M11.741 8.759a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2h8zm-7.414 5.454L2.74 15.831v3.23h9.5V17.77L9.076 15.83l-1.585.807-3.164-2.425zm6.727-1.454a1.2 1.2 0 00-1.188 1.212 1.2 1.2 0 001.188 1.212 1.2 1.2 0 001.187-1.212 1.2 1.2 0 00-1.187-1.212zm2.887-10c3.088 0 5.6 2.512 5.6 5.6v3.669l1.835-1.835a.8.8 0 111.13 1.131l-3.2 3.2a.797.797 0 01-1.13 0l-3.2-3.2a.8.8 0 111.13-1.13l1.835 1.833V8.36c0-2.206-1.794-4-4-4h-2.4a.8.8 0 110-1.6h2.4z" />
      </SvgIcon>
    )
  },
)

export default RotateImage
